<!--
 * @FilePath: SubAgentTree.vue
 * @Author: Aron
 * @Date: 2023-07-20 18:57:30
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-08-21 16:34:42
 * Copyright: 2023 xxxTech CO.,LTD. All Rights Reserved.
 * @Descripttion:
-->
<template>
  <div style="display: inline-block; width: 100%">
    <!-- 替换展示框和搜索框的策略 -->
    <el-input
      class="selectClass"
      :placeholder="inputPlaceholder || $t('app.pleaseSelectUser')"
      v-model="lstUserName"
      v-popover:choseAgentPopover
      v-if="lstUserName && lstUserName != ''"
      readonly
    >
      <span class="el-input__suffix" slot="suffix">
        <span class="el-input__suffix-inner">
          <i
            class="el-select__caret el-input__icon el-icon-arrow-up"
            :class="{
              'is-reverse': showAgentDropDown
            }"
          ></i>
        </span>
      </span>
    </el-input>
    <el-input
      class="selectClass"
      :placeholder="inputPlaceholder || $t('app.pleaseSelectUser')"
      v-model="filterText"
      v-popover:choseAgentPopover
      v-else
    >
      <span class="el-input__suffix" slot="suffix">
        <span class="el-input__suffix-inner">
          <i
            class="el-select__caret el-input__icon el-icon-arrow-down"
            :class="{
              'is-reverse': showAgentDropDown
            }"
          ></i>
        </span>
      </span>
    </el-input>

    <el-popover
      popper-class="agent-popover"
      placement="bottom-start"
      height="300"
      ref="choseAgentPopover"
      trigger="click"
      @show="showAgentDepartmentPopover"
      @hide="hideAgentDepartmentPopover"
      :visible-arrow="false"
    >
      <div>
        <div class="scrollbar-wrapper">
        <!-- <el-input class="keyword-search" :placeholder="searchPlaceholder">
        </el-input> -->
        <vueEasyTree
          :data="dataList"
          show-checkbox
          @check-change="handleCheckChange"
          node-key="id"
          height="200px"
          ref="subAgentTree"
          :filter-node-method="filterNode"
        >
        </vueEasyTree>
      </div>
      </div>
    </el-popover>
  </div>
</template>

<script>
import { queryRegionSubCampusListV2 } from "@/api/SquirrelSettlement";
import { getDeptTreeInfo } from "@/api/basicApi";
import vueEasyTree from "@wchbrad/vue-easy-tree"
import "@wchbrad/vue-easy-tree/src/assets/index.scss"
export default {
  data() {
    return {
      filterAgentTextClass: "",
      agentTreeData: [],
      showAgentDropDown: false,
      lstUserName: "",
      lstUserId: [],
      radios: [],
      dataList: [],
      filterText: ""
    };
  },
  props: {
    isShowLabel: {
      type: Boolean,
      default: false
    },
    inputPlaceholder: {
      type: String,
      default: ""
    },
    isSingleChoice: {
      type: Boolean,
      default: false
    },
    doClear: {
      type: Boolean,
      default: false
    },
	labelId:{
		type:Boolean,
		default:false
	}
  },
  components:{
		vueEasyTree,
	},
  watch: {
    filterText(val) {
      this.$refs.subAgentTree.filter(val);
    },
    doClear(newVal, oldVal) {
      this.clearSelect();
    }
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    handleCheckChange(data) {
      console.log(data);
    },
    async initData() {
      // let CampusTree = [];
      // if (CampusTree <= 0) {
      //   CampusTree = await getDeptTreeInfo();
      //   CampusTree = CampusTree.code === 0 ? CampusTree.data : [];
      // }
      // const that = this;
      // function traverse(val) {
      //   for (let item of val) {
      //     item.label = `${that.breakUpCode(item.value)}-${item.title}`;
      //     item.id = `${that.breakUpCode(item.value)}`;
      //     if (item.children) {
      //       traverse(item.children);
      //     }
      //   }
      // }
      // traverse(CampusTree);
      // this.dataList = [{ label: this.$t('app.selectAll'), children: CampusTree, id: 0 }];

      // let res = await getDeptTreeInfo();
      let res = await queryRegionSubCampusListV2();
      // console.log("res", res);
      let result = [];
      result = res.data.map(e => {
        if (e.childList) {
          let tempList = e.childList.map(e2 => {
            return {
              id: e2.campusId,
              label:this.labelId? e.campusId+"-"+ e2.campusName:e2.campusName,
              children: e2.childs
            };
          });
          return {
            id: e.campusId,
            label:this.labelId? e.campusId+"-"+ e.campusName:e.campusName,
            children: tempList
          };
        } else {
          return {
            id: e.campusId,
            label:this.labelId?e.campusId+"-"+ e.campusName: e.campusName,
            children: e.childs
          };
        }
      });
      this.dataList = result.length ? [
        {
          id: 0,
          label: this.$t('app.selectAll'),
          children: result
        }
      ]:[];
    },
    breakUpCode(val) {
      return val.split("_")[1];
    },
    showAgentDepartmentPopover() {
      this.showAgentDropDown = true;
    },
    hideAgentDepartmentPopover() {
      this.showAgentDropDown = false;
      this.lstUserId = []; //置空一下
      this.lstUserName = "";
      let selectPeopleName = [];
      let selectIdArr = this.$refs.subAgentTree.getCheckedKeys();
      selectIdArr = selectIdArr.filter(e => e !== 0); //把全选的节点去掉
      let selectNodeArr = this.$refs.subAgentTree.getCheckedNodes();
      selectNodeArr = selectNodeArr.filter(e => e.id !== 0); //把全选的节点去掉

      console.log(selectNodeArr);
      if (selectNodeArr.length > 0) {
        selectNodeArr.map(item => {
          selectPeopleName.push(item["label"]);
        });
        this.lstUserName = selectPeopleName.join(",");
        this.lstUserId = selectIdArr;
        this.$emit("input", this.lstUserId); //必须在前面
        this.$emit("select", this.lstUserId);
        this.filterText = "";
      } else {
        this.lstUserName = "";
        this.lstUserId = [];
        this.filterText = "";
        this.$emit("input", []); //必须在前面
        this.$emit("select", []); //为了清空
      }
    },
    clearSelect() {
      this.$refs.subAgentTree.setCheckedNodes([]);
      this.lstUserName = "";
      // this.$refs.subAgentTree.getCheckedKeys([]);
    }
    // monitoring() {
    //   // 监听事件
    //   this.$on("clearSelect", res => {
    //     this.$refs.subAgentTree.setCheckedNodes([]);
    //   });
    // }
  },
  mounted() {
    this.initData();
    // this.monitoring(); // 注册监听事件
  }
};
</script>

<style lang="scss" scoped>
.scrollbar-wrapper{
  // min-width: auto !important;
}
.is-reverse {
  transform: rotate(-180deg);
}
.selectClass {
  width: 100%;
  :deep(.el-input__inner) {
    height: 32px;
  }
}
.scrollbar-wrapper {
	background-color: #ffffff;
	max-height: 250px;
	overflow: auto;
	padding-right: 10px;
	margin-bottom: 10px;
	// .el-scrollbar__wrap {
	//   margin-bottom: -30px !important;
	// }
  }
</style>

<style lang="scss">
.agent-popover {
  max-height: 300px;
  // width: 10%;
  overflow-y: auto;
  .el-tree-node__label {
    font-size: 14px;
    overflow-y: auto;
  }
}
</style>
